import React, { useState } from "react";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

// import JS files
import Header from "../shares/others/Header";
import SupporterCard from "./SupporterCard";

// import others files
import useFetch from "../../context/useFetch";

const Supporter = (props) => {
  let windowWidth = window.screen.width;

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: windowWidth <= 760 ? 1 : 5,
    count: 0,
    previous: null,
    next: null,
  });

  const [supportList, setSupporterList] = useState({ results: [] });
  const getSupportListApi = useFetch({
    method: "get",
    pagination: paginationPageInfo,

    url: "Supporter_Service",
    noHeader: true,
    trigger: true,
    argFunc: (res) => {
      setSupporterList(res);
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
  });

  const handleNextPage = () => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: paginationPageInfo.current + 1,
    });
    getSupportListApi.reFetch();
  };

  const handlePrevPage = () => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: paginationPageInfo.current - 1,
    });
    getSupportListApi.reFetch();
  };

  return (
    <>
      <div className="mt-8 md:mt-16 mb-20">
        <Header header="حامیان ما" noAllItems />
        <div className="relative">
          {paginationPageInfo.previous !== null && (
            <div
              onClick={() => handlePrevPage()}
              className="bg-mygrays-100 p-1 rounded-lg transition-all hover:scale-110 cursor-pointer absolute top-1/2 right-0 transform -translate-y-1/2"
            >
              <ArrowForwardIosIcon className="text-myblacks-100 transition-all hover:text-myblacks-400" />
            </div>
          )}
          <div className="grid grid-cols-10 gap-4 mx-12">
            {supportList.results.map((item, index) => {
              return <SupporterCard logo={item.logo_file} name={item.name} />;
            })}
          </div>

          {paginationPageInfo.next !== null && (
            <div
              onClick={() => handleNextPage()}
              className="bg-mygrays-100 p-1 rounded-lg transition-all hover:scale-110 cursor-pointer absolute top-1/2 left-0 transform -translate-y-1/2"
            >
              <ArrowBackIosNewIcon className="text-myblacks-100 transition-all hover:text-myblacks-400" />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Supporter;
